import { render, staticRenderFns } from "./AddVisitor.vue?vue&type=template&id=56b20d3c&lang=pug&"
import script from "./AddVisitor.vue?vue&type=script&lang=js&"
export * from "./AddVisitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports